import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface VacationEmployee {
  name: string;
  vacation_dates: string[]; // Array of 'YYYY-MM-DD' dates
  parental_leave_dates: string[]; // Array of 'YYYY-MM-DD' dates
}

export interface VacationParams {
  from: string; // 'YYYY-MM-DD'
  to: string; // 'YYYY-MM-DD'
}

interface VacationApiResponse {
  name: string;
  vacation_dates: string; // Comma-separated string from API
  parental_leave_dates?: string; // Comma-separated string from API
}

@Injectable({
  providedIn: 'root',
})
export class VacationService {
  private apiUrl = 'api/vacation';

  constructor(@Inject(HttpClient) private http: HttpClient) {}

  get(params: VacationParams): Observable<VacationEmployee[]> {
    const url = `${this.apiUrl}/${params.from}/${params.to}`;

    return this.http
      .get<VacationApiResponse[]>(url)
      .pipe(map((response) => this.parseVacationDates(response)));
  }

  /**
   * Parse vacation_dates and parental_leave_dates from CSV string to array
   */
  private parseVacationDates(data: VacationApiResponse[]): VacationEmployee[] {
    return data.map((employee) => {
      // Split comma-separated dates into array
      const vacationDates = employee.vacation_dates
        ? employee.vacation_dates.split(',').filter((date) => date.trim() !== '')
        : [];

      const parentalLeaveDates = employee.parental_leave_dates
        ? employee.parental_leave_dates.split(',').filter((date) => date.trim() !== '')
        : [];

      return {
        name: employee.name,
        vacation_dates: vacationDates,
        parental_leave_dates: parentalLeaveDates,
      };
    });
  }
}
